import type { Session } from "next-auth";
import cookies from "js-cookie";

import { jwtEncodeData } from "../../../helpers/jwtHelper";
import { SESSION_COOKIE_LIFE, SESSION_COOKIE_NAME } from "../../../config/global.config";

/**
 * We added the auth set session locally too as the cookie wasn't getting set from the server in all cases.
 */
const setAuthSession = (session: Session) => {
    const jwt = jwtEncodeData(session as Record<keyof Session, unknown>);

    cookies.set(SESSION_COOKIE_NAME, jwt, {
        sameSite: "strict",
        expires: new Date(Date.now() + SESSION_COOKIE_LIFE * 24 * 60 * 60 * 1000),
    });
};

export default setAuthSession;
